/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import { Formik } from "formik";
import { AlertStatus } from "../../../../contants";
import Member from "../../../../services/api/member";
import styles from "./MemberToggleStatus.styles";
import Typography from "../../../../components/common/new/Typography/Typography";
import Button from "../../../../components/common/Button";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import InputField from "../../../../components/common/new/InputField/InputField";

export const FIELDS = {
  REASON: "reason",
  RETAIN_MEMBER_ID: "retainMemberId",
  REMARKS: "remark",
};

const REMARK = "remark";

function RejectedDeactivation({ selectedMember, onClose, callBack }) {
  const [remark, setRemark] = useState("");
  const toast = useContext(ToastAlertContext);
  //   const isActive = selectedMember?.status === ACTIVE;
  // const isDeactivated = selectedMember?.member?.status === DEACTIVATED;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === REMARK) {
      setRemark(value);
    }
  };

  const validateFormData = () => {
    if (!remark) {
      return "Please enter remark";
    }
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const error = validateFormData();
      if (error) {
        return toast.show(error, AlertStatus.ERROR);
      }

      // Valid form data
      const body = {
        // remark,
        remarkDto: {
          data: {
            message: remark,
            event: "remarks",
          },
        },
      };

      await Member.rejectDeactivation({
        data: body,
        applicationId: selectedMember?.id,
      });

      toast.show("Deactivation Rejected Successfully", AlertStatus.SUCCESS);

      setTimeout(() => {
        onClose();
        callBack();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  console.log("selectedMember", selectedMember);

  return (
    <Formik initialValues={{}}>
      {({ values }) => (
        <form onSubmit={onSubmit}>
          {/* {(isActive || isDeactivated) && ( */}
          <Box>
            <Typography>Reject Member Deactivation</Typography>
          </Box>
          {/* )} */}
          <Box style={{ marginTop: "24px" }}>
            <InputField
              name={REMARK}
              variant="outlined"
              label="Enter your remark here..."
              style={styles.inputStyle}
              value={values[FIELDS.REMARKS]}
              onChange={handleInputChange}
              InputProps={{ sx: { minHeight: "91px" } }}
            />
          </Box>
          <div style={{ display: "flex", gap: 20 }}>
            <Button
              variant="contained"
              style={CommonStyles.buttonStyle}
              onClick={onSubmit}
              type="submit"
              label="Reject"
            />
            <Button
              style={CommonStyles.buttonStyle}
              variant="outlined"
              onClick={onClose}
              label="Cancel"
            />
          </div>
        </form>
      )}
    </Formik>
  );
}

export default RejectedDeactivation;
